var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 346"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 473",
    y: 0.5,
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "#3A68D8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.3897 40.4094L37.9518 15.3219C38.2328 14.2483 37.2445 13.2698 36.1603 13.5479L28.6454 15.475C27.6482 15.7301 27.307 16.9621 28.0357 17.6837C28.8817 18.5196 29.6922 19.5791 30.2486 20.7353C30.7018 21.6769 31.85 24.0616 30.8244 25.5522C29.7474 27.115 27.3283 26.1312 26.0432 27.2435C24.7262 28.3857 24.4489 31.638 28.6595 40.6928C28.7253 40.8335 28.816 40.9638 28.928 41.073C29.7314 41.8684 31.1053 41.4988 31.3897 40.4094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.7988 20.0525C10.7983 20.0525 10.7978 20.0526 10.7974 20.0527C9.73873 20.3436 9.73364 21.8336 10.7856 22.1503C14.0241 23.1236 20.469 24.9081 24.55 24.931C25.707 24.938 28.3802 24.9521 29.0485 23.5847C29.0823 23.516 29.1837 23.2943 29.205 22.9106C29.3134 20.9571 27.0739 19.125 25.6021 17.7857C24.7846 17.0413 23.6416 16.758 22.5664 17.0343L10.8268 20.0449C10.8254 20.0453 10.824 20.0456 10.8226 20.046C10.8182 20.047 10.8078 20.0495 10.8008 20.0521C10.8002 20.0524 10.7995 20.0525 10.7988 20.0525Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.54a13929a4021d8efe3e8f0dc100eded.svg";
export { ForwardRef as ReactComponent };